import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    updateProjectAsync
} from '../../../redux/project/Actions';

import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    Divider,
    Modal,
    Paper,
    Typography,
    Badge,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent
} from '@material-ui/core';
import FolderIcon from '@material-ui/icons/Folder';

import TextField from '../../Common/UI/TextField';
import DialogButton from '../../Common/UI/Dialog/DialogButton';

class EditProjectModal extends React.Component {
    constructor (props) {
        super(props);

        this.submitUpdateProject = this.submitUpdateProject.bind(this);

        this.state = {
            projectName: null
        };
    }

    submitUpdateProject (e) {
        e.preventDefault();
        const { onClose, id, currentProject, dispatchUpdateProjectAsync } = this.props;
        const { projectName } = this.state;

        dispatchUpdateProjectAsync(id, projectName);
        onClose();
    }

    render () {
        const { classes, open, onClose, projects, id } = this.props;
        const { projectName } = this.state;
        const selectedProject = projects.find((p) => p.id === id);

        if (id === null) { return null; }

        return (
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <FolderIcon />
                    <Typography variant="h4">
                        Edit Project
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        label="Project name"
                        fullWidth
                        value={projectName || selectedProject.name}
                        onChange={(e) => this.setState({ projectName: e.target.value })}
                    />
                    <div className={classes.row}>
                        <Typography
                            variant="subtitle1"
                        >
                            Created:
                        </Typography>
                        <Typography
                            variant="body2"
                        >
                            {(new Date(selectedProject.createdAt)).toLocaleDateString()}
                        </Typography>
                    </div>
                    <div className={classes.row}>
                        <Typography
                            variant="subtitle1"
                        >
                            Site cards:
                        </Typography>
                        <Typography
                            variant="body2"
                        >
                            {selectedProject.numSiteCards}
                        </Typography>
                    </div>
                </DialogContent>
                <DialogActions>
                    <DialogButton
                        variant="contained"
                        type="submit"
                        onClick={this.submitUpdateProject}
                    >
                        SAVE CHANGES
                    </DialogButton>
                    <DialogButton
                        variant="outlined"
                        onClick={onClose}
                    >
                        CANCEL
                    </DialogButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = (theme) => ({
    row: {
        display: 'flex',
        marginBottom: '10px',
        columnGap: '5px'
    }
});

const mapStateToProps = (state) => ({
    currentProject: state.project.currentProject,
    projects: state.project.projects
});

const mapDispatchToProps = (dispatch) => ({
    dispatchUpdateProjectAsync: (id, name) => dispatch(updateProjectAsync(id, name, null))
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(EditProjectModal);